<script setup lang="ts">
import { humanReadableTimestamp } from '@/composables/datetime'
import { useCameraName } from '@/composables/cameraHelpers'
import GenericCustomDialog from '@/components/GenericCustomDialog.vue'
import ArtifactDisplay from '@/components/artifacts/ArtifactDisplay.vue'
import { Ref, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
defineProps<{
  artifacts: { status: string; artifactId: string; timestamp: number; type: string; data: { cameraId?: string } }[]
}>()

const artifactId = defineModel<string | null>({
  default: null,
})
const artifactIds: Ref<string[]> = ref<string[]>([])

watch(
  artifactIds,
  () => {
    artifactId.value = artifactIds.value.length ? artifactIds.value[0] : null
  },
  { immediate: true, deep: true }
)
const headers = [
  { title: t('filters.artifacts.properties.type.title'), value: 'type' },
  { title: t('filters.artifacts.properties.timestamp.title'), value: 'timestamp' },
  { title: t('filters.artifacts.properties.data.cameraId.title'), value: 'data.cameraId' },
  { title: t('filters.artifacts.properties.status.title'), value: 'status' },
  { title: t('filters.artifacts.properties.jobType.title'), value: 'jobType' },
  { value: 'show' },
]
</script>

<template>
  <v-data-table
    v-model="artifactIds"
    :items-per-page="-1"
    :headers="headers"
    :items="artifacts"
    hide-default-footer
    item-value="artifactId"
    show-select
    select-strategy="single"
  >
    <template #[`item.type`]="{ item }">
      {{ $t('filters.artifacts.properties.type.options.' + item.type + '.title') }}
    </template>
    <template #[`item.timestamp`]="{ item }">
      {{ humanReadableTimestamp(item.timestamp) }}
    </template>
    <template #[`item.data.cameraId`]="{ item }">
      <span v-if="item.data.cameraId">
        {{ useCameraName(item.data.cameraId) }}
      </span>
    </template>
    <template #[`item.status`]="{ item }">
      {{ $t('filters.artifacts.properties.status.options.' + item.status + '.title') }}
    </template>
    <template #[`item.show`]="{ item }">
      <v-btn
        variant="outlined"
        size="small"
      >
        {{ $t('general_interface.buttons.show') }}
        <generic-custom-dialog activator="parent">
          <template #body>
            <ArtifactDisplay :artifact-id="item.artifactId" />
          </template>
        </generic-custom-dialog>
      </v-btn>
    </template>
  </v-data-table>
</template>

<style scoped></style>
